import i18n from 'config/i18n';
import dayjs, { Dayjs } from 'dayjs';
import * as yup from 'yup';

import { getLocale } from './date';

dayjs.locale(getLocale());

export const isValidDate = (fieldName: string) => {
  const t = i18n.getFixedT(getLocale(), 'common');

  return yup
    .mixed<Dayjs>()
    .test(
      'dayjs-valid',
      () => t('invalidDate'),
      (v) => (v ? v.isValid() : false)
    )
    .test(
      'valid-date-range',
      () => t('invalidDateRange'),
      (v) => {
        return v
          ? v.isAfter(dayjs('01-01-1900')) && v.isBefore(dayjs('12-31-2099'))
          : false;
      }
    )
    .required(t('validationFieldRequired', { name: t(fieldName) }));
};

// Use this on endDate or validTo fields for date range validation
export const endDateAfterStartDate = ({
  compareToFieldName,
  startDateTranslation,
  endDateTranslation
}) => {
  const t = i18n.getFixedT(getLocale(), 'common');

  return yup.mixed<Dayjs>().when('noEndDate', {
    is: (noEndDate: boolean) => noEndDate,
    then: yup.mixed<Dayjs>().notRequired(),
    otherwise: yup
      .mixed<Dayjs>()
      .test(
        'dayjs-valid',
        () => t('invalidDate'),
        (v) => (v ? v.isValid() : false)
      )
      .test(
        'valid-date-range',
        () => t('invalidDateRange'),
        (v) => {
          return v
            ? v.isAfter(dayjs('01-01-1900')) && v.isBefore(dayjs('12-31-2099'))
            : false;
        }
      )
      .test(
        'dayjs-min',
        () =>
          t('dateRangeMismatch', {
            startDate: t(startDateTranslation),
            endDate: t(endDateTranslation)
          }),
        (v, ctx) => {
          const start = ctx.parent[compareToFieldName] as Dayjs;
          return v && start ? !v.isBefore(start) : true;
        }
      )
      .required(t('validationFieldRequired', { name: t(endDateTranslation) }))
  });
};
